$(document).ready(function () {
  var $wrapper = $('[data-pdp-variant-modal]');
  var $openBtn = $('[data-pdp-variant-modal-open]')
  var $closeBtn = $('[data-php-variant-modal-close]')

  if ($wrapper.length) {
    $openBtn.on('click', function () {
      $wrapper.css("display", "flex")
        .hide()
        .fadeIn(500);

      $nameInput.focus();
    });

    $closeBtn.on('click', function () {
      $wrapper.fadeOut(500);
    });

  }
});


